export default __webpack_public_path__ + "static/masterDetail-5a129305d71e788c69df9653bb99c137.gif";